import React from 'react';
import Button from './Button';
import AgentCard from './AgentCard';

/**
 * Panel for managing live agents in LVC scenario
 */
const LiveAgentsPanel = ({
  agents,
  getUserByUid,
  profilePictures,
  failedProfilePictures,
  openAgentMenu,
  onMenuToggle,
  onAddUser,
  onSwap,
  onRemove,
  onUserClick,
  onProfilePictureError,
  disabled = false
}) => {
  return (
    <>
      <div className="live-panel-header">
        <h2>Live</h2>
        <Button
          variant="primary"
          size="small"
          onClick={onAddUser}
        >
          Add User
        </Button>
      </div>
      <div className="live-names-list">
        {agents.length === 0 ? (
          <p className="empty-message">No live agents added yet. Click "Add User" to get started.</p>
        ) : (
          <ul className="names-list">
            {agents.map((agent, index) => {
              const user = getUserByUid(agent.uid);
              const profilePictureUrl = user ? profilePictures.get(agent.uid) : null;
              const showProfilePicture = profilePictureUrl && !failedProfilePictures.has(agent.uid);
              const liveMenuKey = `live-${index}`;
              const isMenuOpen = openAgentMenu === liveMenuKey;
              
              return (
                <AgentCard
                  key={index}
                  agent={agent}
                  user={user}
                  profilePictureUrl={profilePictureUrl}
                  showProfilePicture={showProfilePicture}
                  isMenuOpen={isMenuOpen}
                  onMenuToggle={() => onMenuToggle(isMenuOpen ? null : liveMenuKey)}
                  onSwap={() => onSwap(index)}
                  onRemove={() => onRemove(index)}
                  onProfilePictureError={() => onProfilePictureError(agent.uid)}
                  onUserClick={onUserClick}
                  disabled={disabled}
                />
              );
            })}
          </ul>
        )}
      </div>
    </>
  );
};

export default LiveAgentsPanel;
